import integrationsDataService from "../../services/integrationsDataService";
import { IntegrationTypes } from "../types";
import { type SfIntegrationConfigs, PackContent } from "../types/successFactors";
import type IConnector from "./IConnector";

export class SfConnector implements IConnector<SfIntegrationConfigs> {
  private readonly _isConnected: boolean;

  constructor(isConnected: boolean) {
    this._isConnected = isConnected;
  }

  public get info() {
    return {
      id: IntegrationTypes.SuccessFactors,
      connectorTitle: "SuccessFactors",
      type: IntegrationTypes.SuccessFactors,
      description: "SuccessFactors",
      thumbnailUrl: "/connectors/success-factors.png",
      isConnected: this._isConnected,
    };
  }

  public get configuration() {
    return {
      isActive: true,
      isSyncRunning: false,
      packSettings: {
        contentType: PackContent.AllContent,
        packIds: [],
      },
      sftpSettings: {
        host: "",
        username: "",
        password: "",
      },
      columnValues: null,
      tenantId: "",
      isHistoryEnabled: false,
      completionHistorySettings: null,
    };
  }

  public shouldLogin = () => false;

  public shouldNotify = () => false;

  public login = async (_: SfIntegrationConfigs) => {
    throw new Error("SuccessFactors integration does not support login");
  };

  public save = async (config: SfIntegrationConfigs, moboId?: string) => {
    await integrationsDataService.createSfIntegration(config, moboId);
  };
}
